import type { LevelDef } from '../../sim/types';
import { LEVEL_01 } from './01-foerste-vind';
import { LEVEL_02 } from './02-thor-gaar-i-land';
import { LEVEL_03 } from './03-elbil-fredag';
import { LEVEL_04 } from './04-koeen';
import { LEVEL_05 } from './05-naar-vinden-sover';
import { LEVEL_06 } from './06-to-hjerter';

export const LEVELS: readonly LevelDef[] = [LEVEL_01, LEVEL_02, LEVEL_03, LEVEL_04, LEVEL_05, LEVEL_06];

const BY_ID = new Map(LEVELS.map((l) => [l.id, l]));

export function getLevel(id: string): LevelDef {
  const l = BY_ID.get(id) ?? LEVELS.find((x) => String(x.number) === id);
  if (!l) throw new Error(`Ukendt bane: ${id}`);
  return l;
}

/** Kampagnens sidste bane: vinder man den, er kampagnen gennemført. */
export const FINALE_LEVEL = LEVEL_06.id;

/**
 * Er banen låst op? Bane 1-4 er åbne fra start (den korte kampagne fra før). Bane 5 kræver en sejr på
 * bane 4, og bane 6 en sejr på bane 5. `won` er de baner, der er vundet på mindst én sværhed.
 */
export function levelUnlocked(id: string, won: (id: string) => boolean): boolean {
  const i = LEVELS.findIndex((l) => l.id === id);
  if (i < 4) return true;
  const prev = LEVELS[i - 1];
  return prev !== undefined && won(prev.id);
}

export { LEVEL_01, LEVEL_02, LEVEL_03, LEVEL_04, LEVEL_05, LEVEL_06 };
